import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import useDictStore from "@/store/dict";

/**
 * 获取字典
 *
 * 只传入key，将得到索引对应的字典数组；若key是数组，将返回字典数组对象，这在批量获取字典数据时会很方便，比如select选项组
 * 传入value时，将得到value对应的label
 *
 * @param {Array,String} key 字典索引
 * @param {Number,String} value 字典值
 * @returns {Object,Array,String}
 */
export function dict(key, value) {
  // key是数组，返回字典数组对象
  if (Array.isArray(key)) {
    const res = ref({});
    key.forEach(dictType => {
      res.value[dictType] = useDictStore().getDict(dictType);
    });
    return toRefs(res.value);
  }
  // key是字符串
  const dict = useDictStore().getDict(key);
  if (value === undefined) {
    // 没有value，返回key对应的字典数组
    return dict;
  } else {
    // 有value值，返回对应的label
    const act = dict.find(ele => +ele.value === +value);
    if (act) {
      return act.label;
    }
    return '';
  }
}

/**
 * 字典数据
 *
 * `label`,`value`必填
 * todo：可能命名空间冲突，后期使用接口返回的数据
 *
 * @param {String} label 名称
 * @param {String,Number} value 值
 * @param {String} type 类型 可选值`primary / success / warning / danger / info`
 * @param {String} effect 主题 可选值`dark / light / plain`
 * @param {Boolean} round 圆角
 * @param {String} size 尺寸 可选值`medium / small / mini`
 * @returns {Object}
 */

export const dictData = {
  // 性别
  userSex: [{
    label: "男",
    value: 1
  }, {
    label: "女",
    value: 2
  }],
  // 账号状态
  userAccountStatus: [{
    label: "正常",
    value: 1,
    type: "success"
  }, {
    label: "已暂停",
    value: 0,
    type: "info"
  }],
  // 审批状态
  applyStatus: [{
    label: "待审核",
    value: 1,
    type: "info"
  }, {
    label: "通过",
    value: 2,
    type: "success"
  }, {
    label: "驳回",
    value: 3,
    type: "danger"
  }],
  // 订单类型
  orderType: [{
    label: "正常订单",
    value: 1
  }, {
    label: "挪车订单",
    value: 2
  }],
  // 车辆状态
  acc: [{
    label: "驻车中",
    value: 0,
    color: "#333333"
  }, {
    label: "行驶中",
    value: 1,
    color: "#26CF9A"
  }, {
    label: "已离线",
    value: 2,
    color: "#FF5900"
  }],
  // 更新方式
  updateType: [{
    label: "可选更新",
    value: 0
  }, {
    label: "强制更新",
    value: 1
  }],
  //锁定状态
  lockStatus: [{
    label: "已锁定",
    value: 1
  }, {
    label: "已解锁",
    value: 0
  }],
  //绑定状态
  bindStatus: [{
    label: '已绑定',
    value: 1
  }, {
    label: '未绑定',
    value: 0
  }],
  //用车类型
  userCarType: [{
    label: '因公用车',
    value: 1
  }, {
    label: '因私用车',
    value: 2
  }],
  //加入状态
  joinStatus: [{
    label: '未加入',
    value: 0
  }, {
    label: '已加入',
    value: 1
  }, {
    label: '审核中',
    value: 2
  }],
  //审批状态
  procState: [{
    label: '审批中',
    value: 0
  }, {
    label: '已撤销',
    value: 1
  }, {
    label: '未通过',
    value: 3
  }, {
    label: '已通过',
    value: 4
  }],
  //事故类型
  adccidentType: [{
    label: '交通事故',
    value: 1
  }, {
    label: '车辆故障',
    value: 2
  }],
  // 超速状态
  speedStatus: [{
    label: '已关闭',
    value: 0,
    type: 'danger'
  }, {
    label: '已开启',
    value: 1,
    type: 'success'
  }],
  // 结算状态
  payStatus: [{
    label: '待结算',
    value: 0,
    type: 'info'
  }, {
    label: '已结算',
    value: 1,
    type: 'primary'
  }],
  // 用车类型
  carUseType: [{
    label: '因公用车',
    value: 1
  }, {
    label: '因私用车',
    value: 2
  }],
  // 用车状态
  carUseStatus: [{
    label: '用车中',
    value: 1
  }, {
    label: '已完成',
    value: 2
  }],
  // 结束方式
  finishType: [{
    label: '未结束',
    value: 0
  }, {
    label: '用户自行结束',
    value: 1
  }, {
    label: '平台人工结束',
    value: 2
  }],
  // 账单状态
  billStatus: [{
    label: '未申请开票',
    value: 1
  },
  // { label: '开票中', value: 2 },
  {
    label: '已开票，待转账',
    value: 3
  }
  // { label: '转账中', value: 4 },
  // { label: '已到账', value: 5 },
  ],
  // 操作人类型
  optUserType: [{
    label: '用车单位',
    value: 1
  }, {
    label: '平台方',
    value: 2
  }],
  // 操作状态
  optStatus: [{
    label: '未申请开票',
    value: 1
  }, {
    label: '申请开票',
    value: 2
  }, {
    label: '完成开票，待转账',
    value: 3
  }, {
    label: '已申请转账 ',
    value: 4
  }, {
    label: '已核账',
    value: 5
  }],
  // 操作状态
  alarmType: [{
    label: '开始用车',
    value: 1
  }, {
    label: '熄火',
    value: 2
  }, {
    label: '点火',
    value: 3
  }, {
    label: '结束用车 ',
    value: 4
  }],
  // 验车单状态
  checkOrderStatus: [{
    label: '待审核',
    value: 1,
    type: 'info'
  }, {
    label: '已审核',
    value: 2,
    type: 'primary'
  }],
  // 验车结果
  checkResultStatus: [{
    label: '未处理',
    value: 0
  }, {
    label: '与取车时一致',
    value: 1
  }, {
    label: '与取车时不一致',
    value: 2
  }],
  // 租赁状态
  rentStatus: [{
    label: '空闲中',
    value: 1,
    color: '#0166FE'
  }, {
    label: '租赁中',
    value: 2,
    color: '#26CF9A'
  }],
  // 车身结构
  carBody: [{
    label: "轿车",
    value: 1
  }, {
    label: "越野车(SUV)",
    value: 2
  }, {
    label: "商务车(MPV)",
    value: 3
  }, {
    label: "中型客车",
    value: 4
  }, {
    label: "大型客车",
    value: 5
  }, {
    label: "货车",
    value: 6
  }, {
    label: "皮卡",
    value: 7
  }, {
    label: "面包车",
    value: 8
  }, {
    label: "洒水车",
    value: 9
  }, {
    label: "垃圾车",
    value: 10
  }, {
    label: "吸污车",
    value: 11
  }, {
    label: "吸粪车",
    value: 12
  }, {
    label: "清洗车",
    value: 13
  }, {
    label: "清扫车",
    value: 14
  }, {
    label: "吸尘车",
    value: 15
  }, {
    label: "清雪车",
    value: 16
  }, {
    label: "运渣车",
    value: 17
  }, {
    label: "高空作业车",
    value: 18
  }, {
    label: "深度保洁车",
    value: 19
  }, {
    label: "其他",
    value: 99
  }]
};